export default __webpack_public_path__ + "static/media/edit_icon.c550570f.svg";